// ScrollSelect - a compact, styled, height-capped dropdown used by the Shifts
// time pickers (Hour / Minute / AM-PM). Replaces native <select> so a 24-item
// hour list scrolls inside a fixed-height menu instead of a giant native popover.
//
//   • max-height menu that scrolls (see .shift-ss-menu in Shifts.css)
//   • auto-scrolls to the selected option when opened
//   • closes on outside click
//   • caret + muted placeholder when nothing is selected
//   • selected option highlighted in brand orange
//
// value/onChange stay plain strings so callers keep building a 24h "HH:MM".

import React, { useState, useEffect, useRef } from "react";
import { FaChevronDown } from "react-icons/fa";
import "./ScrollSelect.css";

const ScrollSelect = ({ value, options, onChange, placeholder, minWidth = 68, up = false }) => {
    const [open, setOpen] = useState(false);
    const ref = useRef(null);
    const menuRef = useRef(null);

    useEffect(() => {
        if (!open) return;
        const onDoc = (e) => { if (ref.current && !ref.current.contains(e.target)) setOpen(false); };
        document.addEventListener("mousedown", onDoc);
        return () => document.removeEventListener("mousedown", onDoc);
    }, [open]);

    useEffect(() => {
        if (open && menuRef.current) {
            const active = menuRef.current.querySelector(".shift-ss-opt.active");
            if (active) active.scrollIntoView({ block: "nearest" });
        }
    }, [open]);

    const selected = options.find((o) => String(o.value) === String(value));
    return (
        <div className="shift-ss" ref={ref} style={{ minWidth }}>
            <button type="button" className="shift-ss-btn" onClick={() => setOpen((o) => !o)}>
                <span className={selected ? "" : "shift-ss-ph"}>{selected ? selected.label : placeholder}</span>
                <FaChevronDown className="shift-ss-caret" />
            </button>
            {open && (
                <ul className={`shift-ss-menu${up ? " up" : ""}`} ref={menuRef}>
                    {options.map((o) => (
                        <li
                            key={o.value}
                            className={`shift-ss-opt${String(o.value) === String(value) ? " active" : ""}`}
                            onClick={() => { onChange(o.value); setOpen(false); }}
                        >
                            {o.label}
                        </li>
                    ))}
                </ul>
            )}
        </div>
    );
};

export default ScrollSelect;
